/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Enums
 */
export enum AssetType {
    Video = 'Video',
    Image = 'Image',
    Audio = 'Audio',
    Document = 'Document',
}
